__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-07-09-1783601186-stable-dev/";